angular.module('tgaAdmin').directive('customOnChange', () => ({
  restrict: 'A',
  link(scope, element, attrs) {
    const onChangeHandler = scope.$eval(attrs.customOnChange);
    element.on('change', onChangeHandler);
    element.on('$destroy', () => {
      element.off();
    });
  },
}));
